import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail } from 'lucide-react';

function Footer() {
  const location = useLocation();
  const onHome = location.pathname === '/';

  const anchor = (hash) => (onHome ? hash : `/${hash}`);

  return (
    <footer className="border-t border-border bg-bg">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-lg bg-gradient-brand flex items-center justify-center font-display font-bold text-white">S</span>
            <span className="font-display font-bold text-lg text-text">Sudco Solutions</span>
          </div>
          <p className="text-sm text-text-muted max-w-xs">
            Modern websites for small businesses, plus web and AI consulting for teams that want to ship.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-text mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-text-muted">
            <li><Link to="/demos" className="hover:text-text">Demos</Link></li>
            <li><a href={anchor('#services')} className="hover:text-text">Services</a></li>
            <li><a href={anchor('#process')} className="hover:text-text">Process</a></li>
            <li><Link to="/pricing" className="hover:text-text">Pricing</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-text mb-3">Get in touch</h4>
          <a href="mailto:nate@sudcosolutions.com" className="flex items-center gap-2 text-sm text-text-muted hover:text-text">
            <Mail size={16} /> nate@sudcosolutions.com
          </a>
          <p className="text-xs text-text-muted mt-3">Replies usually within a day.</p>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center text-xs text-text-muted gap-2">
          <p>&copy; {new Date().getFullYear()} Sudco Solutions. All rights reserved.</p>
          <p>Built in React · Hosted with care.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
